import dayjs from "dayjs";

import { useMemo } from "react";

import { FilterOptionsCount, FilterSourceData } from "../typing";
import { getBanksByProgram } from "../utils";
import { lastTimeOptions } from "../utils/constants";

function count(
  list: FilterSourceData,
  type: "total" | "progress",
  result: FilterOptionsCount
): FilterOptionsCount {
  if (!result["programs"]) {
    result["programs"] = {} as FilterOptionsCount["programs"];
  }

  if (!result["banks"]) {
    result["banks"] = {} as FilterOptionsCount["banks"];
  }
  if (!result["lastSeenTime"]) {
    result["lastSeenTime"] = {} as FilterOptionsCount["lastSeenTime"];
  }

  const programs = result["programs"];
  const banks = result["banks"];

  for (let index = 0; index < list.length; index++) {
    // programs
    const programCode = list[index].program;

    if (programs[programCode]) {
      programs[programCode][type]++;
    } else {
      programs[programCode] =
        type === "total"
          ? {
              total: 1,
              progress: 0,
            }
          : {
              total: 0,
              progress: 1,
            };
    }

    // banks
    const bankList = getBanksByProgram(programCode);
    bankList.forEach((bank) => {
      if (banks[bank]) {
        banks[bank][type]++;
      } else {
        banks[bank] =
          type === "total"
            ? {
                total: 1,
                progress: 0,
              }
            : {
                total: 0,
                progress: 1,
              };
      }
    });

    // lastSeenTime
    const diff = dayjs().diff(dayjs(list[index].points.ls * 1000), "second");

    const options = lastTimeOptions.map((item) => item.value);

    for (const key of options) {
      if (!result["lastSeenTime"][key]) {
        result["lastSeenTime"][key] = {
          total: 0,
          progress: 0,
        };
      }
    }

    if (type === "progress") {
      let startIndex = 0;

      for (let index = 0; index < options.length; index++) {
        if (diff > Number(options[index])) {
          startIndex = index + 1;
        }
      }

      const restOptions = options.slice(startIndex);
      for (const key of restOptions) {
        result["lastSeenTime"][key][type]++;
      }
    } else {
      for (const key of options) {
        result["lastSeenTime"][key][type]++;
      }
    }
  }

  return result;
}

export const useFilterOptionsCount = (
  list: FilterSourceData,
  data: FilterSourceData
): FilterOptionsCount => {
  return useMemo(() => {
    const result = {} as FilterOptionsCount;
    count(list, "total", result);
    count(data, "progress", result);

    return result;
  }, [list, data]);
};
